import axios from "axios";
import _ from "lodash";
import moment from "moment-timezone";

import config from "../config";
import CropService from "./CropService";
import StateService from "./StateService";
import AuthorService from "./AuthorService";

export default class ZoomService {
  static getJWTToken() {
    return axios.get(`${config.baseUrl}/meeting/jwtToken`);
  }

  static getRecordedMeetings(stateName) {
    return axios.get(`${config.baseUrl}/meeting/recording/${stateName}`);
  }

  static getUpcomingMeetings(stateName) {
    return axios.get(`${config.baseUrl}/meeting/upcoming/${stateName}`);
  }

  static getLiveMeetings(stateName) {
    return axios.get(`${config.baseUrl}/meeting/live/${stateName}`);
  }

  static getLiveLiveHelp(stateName) {
    return axios.get(`${config.baseUrl}/meeting/livehelp/live/${stateName}`);
  }

  static getUpcomingLiveHelp(stateName) {
    return axios.get(
      `${config.baseUrl}/meeting/livehelp/upcoming/${stateName}`
    );
  }

  static filterRecordings = (recordedMeetingsFromService) => {
    const fileSizeThreashold = 1000000; //10 mb
    recordedMeetingsFromService = _.filter(
      recordedMeetingsFromService,
      (recordedMeeting) => {
        if (
          recordedMeeting &&
          recordedMeeting.video &&
          recordedMeeting.video.play_url &&
          recordedMeeting.video.file_size > fileSizeThreashold
        ) {
          return recordedMeeting;
        }
      }
    );
    return recordedMeetingsFromService;
  };

  static parseMeetings = (
    meetings,
    userLangCode,
    userStateName,
    crops,
    states,
    authors
  ) => {
    let meetingsFromService = [];

    if (meetings && meetings.length > 0 && _.isArray(meetings)) {
      _.forEach(meetings, (meeting) => {
        let topic = meeting.topic;
        let topicDetailsArray = topic.split("||");
        if (
          topicDetailsArray &&
          (topicDetailsArray.length === 8 ||
            topicDetailsArray.length === 9 ||
            topicDetailsArray.length === 10)
        ) {
          // कांदा - पीक व्यवस्थापन || Onion || Rajani Patil || आठवडा २ || २३ सप्टेंबर २०२० || Maharashtra + Rajasthan || मूलभूत पीक व्यवस्थापन || पीक संरक्षण - पीक पोषण - वातावरण इशारा - पीक टिप्स - प्रश्नोत्तरे || Free
          let [
            cropName,
            sessionTopic,
            authorName,
            week,
            date,
            stateNames,
            shortDescription,
            longDescription,
            freemium,
            youtube,
          ] = topicDetailsArray;

          if (longDescription) {
            longDescription = longDescription.split("-");
          }
          let videoFile = "";
          if (meeting.recording_files && meeting.recording_files.length > 0) {
            videoFile = _.filter(meeting.recording_files, (file) => {
              return file.file_type === "MP4";
            })
              ? _.filter(meeting.recording_files, (file) => {
                  return file.file_type === "MP4";
                })[0]
              : null;
          }
          let userStateMatched = this.parseAndMatchUserState(
            stateNames,
            states,
            userStateName
          );

          let crop = {};
          let author = {};
          crop = CropService.getCropByName(crops, cropName);
          author = AuthorService.getAuthorByName(authors, authorName);

          let free = false;
          if (topicDetailsArray.length === 9) {
            if (freemium.trim().toLowerCase() === "free") {
              free = true;
            }
          }
          let yt = false;
          if (topicDetailsArray.length === 9) {
            if (freemium.trim() === "YT") {
              yt = true;
            }
          }
          if (topicDetailsArray.length === 10) {
            if (youtube.trim() === "YT") {
              yt = true;
            }
          }

          // console.log({ crop }, { author }, { userStateMatched });
          let meetingObjectToPush = {};
          if (
            crop &&
            author &&
            userStateMatched &&
            userStateMatched.length > 0
          ) {
            meetingObjectToPush = {
              crop: crop,
              cropName: crop[`name_${userLangCode}`],
              cropImage: `${config.gcpBucketBase}content${encodeURIComponent(
                crop.image_thumbnail
              )}?alt=media`,
              cropImageLive: `${
                config.gcpBucketBase
              }content${encodeURIComponent(crop.image_live)}?alt=media`,
              sessionTopic,
              author: author,
              authorName: author[`name_${userLangCode}`],
              authorImage: `${config.gcpBucketBase}content${encodeURIComponent(
                author.image_avatar
              )}?alt=media`,
              week,
              date,
              state: userStateMatched,
              shortDescription,
              longDescription,
              startTime: moment(meeting.start_time).local().format("D MMM, LT"),
              id: meeting.id,
              video: videoFile ? videoFile : "",
              joinUrl: meeting.join_url,
              free: free,
              page_url: meeting.page_url ? meeting.page_url : "",
              yt: yt,
            };

            meetingsFromService.push(meetingObjectToPush);
          }
        }
      });
    }

    return meetingsFromService;
  };

  static parseAndMatchUserState(stateNames, states, userStateName) {
    let stateNamesArray = stateNames.split("+");

    let statesFromMeeting = [];
    stateNamesArray.forEach((stateName) => {
      let stateMatched = StateService.getStateByName(
        states,
        stateName.trim().toLowerCase()
      );
      if (!_.isEmpty(stateMatched)) {
        statesFromMeeting.push(stateMatched);
      }
    });

    let userStateMatched = _.filter(statesFromMeeting, (stateFromMeeting) => {
      return (
        stateFromMeeting.name_en.toLowerCase() === userStateName.toLowerCase()
      );
    });
    return userStateMatched;
  }

  static parseLiveHelp(meetings, type, states, userStateName) {
    if (type === "live") {
    }
    let liveHelpMeetings = [];
    _.forEach(meetings, (meeting) => {
      const meetingDetails = meeting.topic.split("||");
      if (
        (meetingDetails.length === 5 || meetingDetails.length === 6) &&
        meeting.start_time &&
        meeting.duration
      ) {
        const [
          meetingType,
          sessionTopic,
          author,
          stateNames,
          freemium,
          unifyd,
        ] = meetingDetails;
        let userStateMatched = this.parseAndMatchUserState(
          stateNames,
          states,
          userStateName
        );

        let free = false;
        if (meetingDetails.length === 5) {
          if (freemium.trim().toLowerCase() === "free") {
            free = true;
          }
        }
        let unifydFlag = false;
        if (meetingDetails.length === 5) {
          if (freemium.trim() === "Unifyd") {
            unifydFlag = true;
          }
        }
        if (meetingDetails.length === 6) {
          if (unifydFlag.trim() === "Unifyd") {
            unifydFlag = true;
          }
        }

        if (userStateMatched && userStateMatched.length > 0) {
          liveHelpMeetings.push({
            meetingType,
            sessionTopic,
            type,
            author,
            state: userStateMatched,
            start_time: moment.tz(meeting.start_time, "Asia/Calcutta"),
            end_time: moment
              .tz(meeting.start_time, "Asia/Calcutta")
              .add(meeting.duration, "minutes"),
            join_url: meeting.join_url,
            id: meeting.id,
            free: free,
            unifyd: unifydFlag,
          });
        }
      }
    });
    return liveHelpMeetings;
  }

  static mapByCrop(recordedMeetingsFromService) {
    let recordedMeetinsgByCrop = {};
    _.map(recordedMeetingsFromService, (recordedMeeting) => {
      let crop = recordedMeeting.crop.name_en;
      let currentCrops = recordedMeetinsgByCrop[crop];
      if (!currentCrops) {
        recordedMeetinsgByCrop[crop] = [];
        currentCrops = [];
      }
      currentCrops.push(recordedMeeting);
      recordedMeetinsgByCrop[crop] = currentCrops;
    });
    return recordedMeetinsgByCrop;
  }

  static mapAllByCrop(liveMeetings, upcomingMeetings, recordedMeetings, crops) {
    let meetingsByCrop = {};
    _.map(liveMeetings, (liveMeeting) => {
      let crop = _.toLower(liveMeeting.crop.name_en.toLowerCase());
      let currentCrops = [];
      if (meetingsByCrop[crop] && meetingsByCrop[crop]["live"]) {
        currentCrops = meetingsByCrop[crop]["live"];
      }

      if (currentCrops.length === 0) {
        meetingsByCrop[crop] = {};
        meetingsByCrop[crop]["live"] = [];
        currentCrops = [];
      }
      currentCrops.push(liveMeeting);
      meetingsByCrop[crop]["live"] = currentCrops;
    });
    _.map(upcomingMeetings, (upcomingMeeting) => {
      let crop = _.toLower(upcomingMeeting.crop.name_en);
      let currentCrops = [];
      if (meetingsByCrop[crop] && meetingsByCrop[crop]["upcoming"]) {
        currentCrops = meetingsByCrop[crop]["upcoming"];
      }
      if (currentCrops.length === 0) {
        meetingsByCrop[crop] = {};
        meetingsByCrop[crop]["upcoming"] = [];
        currentCrops = [];
      }
      currentCrops.push(upcomingMeeting);
      meetingsByCrop[crop]["upcoming"] = currentCrops;
    });
    _.map(recordedMeetings, (recordedMeeting) => {
      let crop = _.toLower(recordedMeeting.crop.name_en);
      let currentCrops = [];
      if (meetingsByCrop[crop] && meetingsByCrop[crop]["recorded"]) {
        currentCrops = meetingsByCrop[crop]["recorded"];
      }
      if (currentCrops.length === 0) {
        meetingsByCrop[crop] = {};
        meetingsByCrop[crop]["recorded"] = [];
        currentCrops = [];
      }
      currentCrops.push(recordedMeeting);
      meetingsByCrop[crop]["recorded"] = currentCrops;
    });

    Object.keys(meetingsByCrop).forEach((crop, index) => {
      meetingsByCrop[crop]["crop"] = CropService.getCropByName(crops, crop);
    });
    return meetingsByCrop;
  }
}
